/*
 * This file has been ported from the original codebase and is used to generate the links for the user based on their roles.
 */

const appLinks = {
  admin: {
    label: 'Admin Dashboard',
    url: '/admin/dashboard',
  },
  frontdesk: {
    label: 'Front Desk',
    url: '/admin/frontdesk',
  },
  np: {
    label: 'Nurse Practitioner Dashboard',
    url: '/np/dashboard',
  },
  npView: {
    label: 'Nurse Practitioner Dashboard',
    url: '/np/dashboard/referrals?view=np',
  },
  npCoordinator: {
    label: 'NP Coordinator Dashboard',
    url: '/np/dashboard/referrals?view=np_coordinator',
  },
  radiology: {
    label: 'Radiology Dashboard',
    url: '/radiologist/portal/dashboard',
  },
  technologist: {
    label: 'Technologist Dashboard',
    url: '/technologist/dashboard',
  },
  user: {
    label: 'User Dashboard',
    url: '/user/dashboard',
  },
};

const getLocalPort = (linkUrl: string) => {
  if (typeof window !== 'undefined' && !window.location.href.includes('localhost')) {
    return linkUrl;
  }
  switch (linkUrl) {
    case '/admin/dashboard':
    case '/admin/frontdesk':
    case '/radiologist/portal/dashboard':
    case '/np/old/dashboard':
      return `http://dev.localhost:5000${linkUrl}`;

    case '/np/dashboard':
    case '/np/dashboard?view=np_coordinator':
    case '/np/dashboard?view=np':
      return `http://dev.localhost:3050${linkUrl}`;

    case '/radiologist/dashboard/':
    case '/technologist/dashboard':
      return `http://dev.localhost:3060${linkUrl}`;

    case '/user/dashboard':
    case '/user/profile':
      return `http://dev.localhost:3020${linkUrl}`;

    default:
      return linkUrl;
  }
};

const getAppLinks = () => {
  const adjustedAppLinks = appLinks;
  Object.entries(appLinks).map(
    ([appLinkKey, appLinkValue]) =>
      // @ts-ignore
      (adjustedAppLinks[appLinkKey].url = getLocalPort(appLinkValue.url)),
  );
  return adjustedAppLinks;
};

export const getAppLinksForUser = (roles: string[]) => {
  const hasAdminAccess = roles.some((role) => ['admin', 'superadmin'].includes(role));
  const hasFrontdeskAccess = roles.some((role) => role === 'frontdesk');
  const hasNPAccess = roles.some((role) => role === 'np');
  const hasNPCoordinatorAccess = roles.some((role) => role === 'np_coordinator');
  const hasUserAccess = roles.some((role) => role === 'user');
  const hasTechDashboardAccess = roles.some((role) => role === 'technologist');
  const hasPartnerPhysicianAccess = roles.some((role) => role === 'partner_physician');
  const hasPartnerEnterpriseAccess = roles.some((role) => role === 'partner_portal');

  const partners = roles
    .filter((role) => role.startsWith('partners'))
    .map((role) => {
      const partnerName = role.split('|')[1];
      const partnerSlug = role.split('|')[2];
      return { partnerSlug, partnerName };
    });

  const hasRadiologyAccess = roles.some((role) =>
    ['radiologist', 'technician', 'coordinator', 'transcriber'].includes(role),
  );

  const appLinks = getAppLinks();

  const userAppLinks = [];

  if (hasAdminAccess) {
    userAppLinks.push(appLinks.admin);
  }

  if (hasFrontdeskAccess) {
    userAppLinks.push(appLinks.frontdesk);
  }

  if (hasNPAccess) {
    if (hasNPCoordinatorAccess) {
      userAppLinks.push(appLinks.npView);
    } else {
      userAppLinks.push(appLinks.np);
    }
  }

  if (hasNPCoordinatorAccess) {
    userAppLinks.push(appLinks.npCoordinator);
  }

  if (hasRadiologyAccess) {
    userAppLinks.push(appLinks.radiology);
  }

  if (hasTechDashboardAccess) {
    userAppLinks.push(appLinks.technologist);
  }

  if (hasUserAccess) {
    userAppLinks.push(appLinks.user);
  }

  partners.forEach(({ partnerSlug, partnerName }) => {
    if (hasPartnerPhysicianAccess) {
      userAppLinks.push({
        label: `${partnerName}`,
        url: `/physician/${partnerSlug}`,
      });
    }

    if (hasPartnerEnterpriseAccess) {
      userAppLinks.push({
        label: `${partnerName} Booking Portal`,
        url: `/portal/${partnerSlug}`,
      });
    }
  });

  return userAppLinks;
};
